export default __webpack_public_path__ + "static/ApercuLAPhil-Medium-ded7ab3fd1d59d6fcff9d53d29d163c9.woff";